
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ScheduleItem } from '@/Model/checkout/cart/types'
import PaymentScheduleEntry from './PaymentScheduleEntry.vue'

@Component({
  components: {
    PaymentScheduleEntry
  }
})
export default class PaymentSchedule extends Vue {
  @Prop({ default: '' }) title!: string
  @Prop({ default: '' }) subtitle!: string
  @Prop({ default: '' }) hint!: string
  @Prop({ default: () => [] }) items!: ScheduleItem[]
  @Prop({ default: '' }) payTodayLabel!: string
}
